import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/rami-uso-comercial-embalaje.svg'

const imgHeader = "./images/productos/header-productos-rami.jpg";
const imgThumbIzq = "./images/productos/productos_thumbs--cinta-empaque-rami.jpg";
const altText = "CINTA DE EMPAQUE";

const tipoColor = 'productos__detail--tipoEmpaqueRami'

const detailLine1 = "CINTAS";
// const detailLine2 = "ADHESIVA";
const detailLine3 = "DE EMPAQUE";

const imgTable ="./images/productos/rami/cuadro-rami-cinta-empaque.jpg";


const textoDetail1 = 'Cintas de polipropileno para sellar cajas de cartón, embalajes varios, armado de paquetes y otras múltiples aplicaciones. Permiten un empaque seguro y resistente.'
const textoDetail2 = 'Vienen en diversos anchos y largos, adaptables al uso comercial e industrial. Se aplican de manera manual o mediante racionadores. Disponibles en transparente, marrón y colores surtidos, recomendables para delimitar áreas, decorar, codificar e identificar objetos, etc.'

const imgThumb1 = './images/productos/rami/rami-cinta-de-empaque-1.jpg';
const imgThumb1Alt = 'Cintas adhesivas de empaque transparente.';

const imgThumb2 = './images/productos/rami/rami-cinta-de-empaque-2.jpg';
const imgThumb2Alt = 'Cintas adhesivas de empaque de opaca.';

const imgThumb3 = './images/productos/rami/rami-cinta-de-empaque-3.jpg';
const imgThumb3Alt = 'Cintas adhesivas de empaque transparente.';

// const imgThumb4 = './images/productos/rami/rami-cinta-de-empaque-4.jpg';
// const imgThumb4Alt = 'Cintas adhesivas de Fragil.';

// const imgThumb5 = './images/productos/rami/rami-cinta-de-empaque-5.jpg';
// const imgThumb5Alt = 'Cintas adhesivas de empaque colores.';

// const imgThumb6 = './images/productos/rami/rami-cinta-de-empaque-6.jpg';
// const imgThumb6Alt = 'Cintas adhesivas de faja de seguridad.';

const CintaEmpaqueRami = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className={`productos__detail--tipo ${tipoColor}`}>{detailLine1}
                 {/* <span className={`productos__detail--caracteristica ${tipoColor}`}> {detailLine2}</span> */}
                </p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine3}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
            {textoDetail1}<br />
            {textoDetail2}
            </p>
          </div>
        </div>
        <div className='row'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
            {/* <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb4} className='d-block w-100 p-0 m-0 ' alt={ imgThumb4Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb5} className='d-block w-100 p-0 m-0 ' alt={ imgThumb5Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb6} className='d-block w-100 p-0 m-0 ' alt={ imgThumb6Alt} loading="lazy" />
            </div> */}
        </div>       
      </Container>
    
  )
}

export default CintaEmpaqueRami